export default "__VITE_ASSET__B1cU99Am__"